/** Current legal document versions accepted at signup. */

export const TERMS_VERSION = '2026-09-15';
export const PRIVACY_VERSION = '2026-09-15';

export const TERMS_URL = 'https://demandjetapp.com/terms';
export const PRIVACY_URL = 'https://demandjetapp.com/privacy';

export function assertTermsAccepted({
  acceptedTerms,
  termsVersion = TERMS_VERSION,
  privacyVersion = PRIVACY_VERSION,
} = {}) {
  if (!acceptedTerms) {
    throw new Error('Please agree to the Terms of Service and Privacy Policy to continue.');
  }
  if (String(termsVersion || '') !== TERMS_VERSION) {
    throw new Error('Please review and accept the latest Terms of Service.');
  }
  if (String(privacyVersion || '') !== PRIVACY_VERSION) {
    throw new Error('Please review and accept the latest Privacy Policy.');
  }
  return {
    acceptedTerms: true,
    termsVersion: TERMS_VERSION,
    privacyVersion: PRIVACY_VERSION,
    acceptedAt: new Date().toISOString(),
  };
}
